export default __webpack_public_path__ + "1fcb2885c5e9355b5f1286e18549154d.png";